module.exports = __webpack_public_path__ + "img/top-image.f86ee04e.png";